import script from "./SurveysTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveysTable.vue?vue&type=script&setup=true&lang=js"

import "./SurveysTable.vue?vue&type=style&index=0&id=69edfb56&lang=scss"

const __exports__ = script;

export default __exports__